module.exports = __webpack_public_path__ + "static/04-bae95f955e254785ceb443dc9440825c.png";